// Bandeja de entrada: lo que se capturó sin proyecto reconocible.
//
// Cada nota con un selector al lado: un toque y queda archivada. La idea es
// vaciarla, no que se acumule.

import { api } from "../api";
import { esc } from "../html";
import { ETIQUETA_TIPO_TAREA, claseTipoTarea, clasePrioridad, claseUrgencia, textoUrgencia } from "../etiquetas";
import type { ProyectoListado, Tarea } from "../../lib/tipos";
import { hoyMontevideo, formatoLocal, urgencia } from "../../lib/fecha";

export async function renderBandeja(contenedor: HTMLElement): Promise<void> {
  async function pintar(): Promise<void> {
    const [tareas, proyectos] = await Promise.all([
      api.get<Tarea[]>("/api/tareas?sin_proyecto=1"),
      api.get<ProyectoListado[]>("/api/proyectos"),
    ]);
    const hoy = hoyMontevideo();

    contenedor.innerHTML = `
      <h1 class="titulo-pagina">Bandeja de entrada</h1>
      <p class="subtitulo">
        ${
          tareas.length
            ? `${tareas.length} ${tareas.length === 1 ? "nota sin archivar" : "notas sin archivar"}`
            : "Vacía. Todo archivado."
        }
      </p>

      <div class="mt-4 space-y-2">
        ${
          tareas.length
            ? tareas
                .map((t) => {
                  const u = urgencia(t.vence_el, hoy);
                  return `
          <div class="fila p-3">
            <div class="break-words">${esc(t.titulo)}</div>
            <div class="mt-1.5 flex flex-wrap items-center gap-1.5">
              <span class="${claseTipoTarea(t.tipo)}">${ETIQUETA_TIPO_TAREA[t.tipo]}</span>
              <span class="${clasePrioridad(t.prioridad)}">P${t.prioridad}</span>
              ${
                u && t.vence_el
                  ? `<span class="${claseUrgencia(u)}">${textoUrgencia(u, formatoLocal(t.vence_el))}</span>`
                  : ""
              }
              ${t.origen === "DICTADO" ? `<span class="chip">dictada</span>` : ""}
            </div>
            ${
              t.detalle && t.detalle !== t.titulo
                ? `<p class="mt-1.5 text-xs italic text-apagado">«${esc(t.detalle)}»</p>`
                : ""
            }
            <div class="mt-2.5 flex gap-2">
              <select class="campo sProyecto flex-1" data-id="${t.id}">
                <option value="">Archivar en…</option>
                ${proyectos.map((p) => `<option value="${p.id}">${esc(p.nombre)}</option>`).join("")}
              </select>
              <button type="button" class="bDescartar btn-sec px-3 text-apagado" data-id="${t.id}"
                      title="Descartar">×</button>
            </div>
          </div>`;
                })
                .join("")
            : `<div class="tarjeta text-center text-apagado">
                 Nada por acá. Lo que dictes sin un proyecto reconocible cae en esta pantalla.
               </div>`
        }
      </div>

      <p class="mt-4 text-xs text-apagado">
        El texto en cursiva es el dictado original, tal cual salió. Queda guardado siempre, por si el
        recorte del título se comió algo.
      </p>`;

    // Elegir proyecto archiva al toque: sin botón de confirmar.
    contenedor.querySelectorAll<HTMLSelectElement>(".sProyecto").forEach((s) => {
      s.addEventListener("change", async () => {
        if (!s.value) return;
        await api.put(`/api/tareas/${s.dataset.id}`, { proyecto_id: Number(s.value) });
        await pintar();
      });
    });

    contenedor.querySelectorAll<HTMLButtonElement>(".bDescartar").forEach((b) => {
      b.addEventListener("click", async () => {
        if (!confirm("¿Descartar la nota? Queda anulada, no se borra.")) return;
        await api.del(`/api/tareas/${b.dataset.id}`);
        await pintar();
      });
    });
  }

  try {
    await pintar();
  } catch (e) {
    contenedor.innerHTML = `<div class="tarjeta text-alerta">No se pudo cargar la bandeja: ${esc(
      e instanceof Error ? e.message : "error desconocido",
    )}</div>`;
  }
}
